import React from 'react';
import PropTypes from 'prop-types';

import { ReactInternetSpeedMeter } from 'react-internet-meter';

import theme from './ConnectionMeter.scss';


const propTypes = {
  onPing: PropTypes.string.isRequired,
};

const ConnectionMeter = ({ onPing }) => (
  // <div className={ theme.root }>
  //   <ReactInternetSpeedMeter
  //     pingInterval={ 3000 }
  //     thresholdUnit="megabyte" // "byte" , "kilobyte", "megabyte"
  //     imageUrl="https://static.elevate.ummanu.health/test/test.png"
  //     downloadSize="106496"
  //     callbackFunctionOnNetworkDown={ onPing }
  //     callbackFunctionOnNetworkTest={ onPing }
  //   />
  // </div>
  <></>
);

ConnectionMeter.propTypes = propTypes;

export default ConnectionMeter;
